import styled from "styled-components";

import { media } from "../styles/media";

export const ManageBranchesStyles = styled.section`
  min-height: calc(100vh - 42px);

  .searchContainer {
    position: relative;
    display: flex;
    align-items: center;
    width: 250px;
    height: 36px;

    ${media.maxMobile`
      width: 100%;
    `}

    .icon {
      position: absolute;
      top: 10px;
      left: 14px;
      z-index: 1;
    }

    .searchInput {
      position: absolute;
      top: 0;
      left: 0;
      border: 1px solid ${({ theme }) => theme.colors.primary[100]};
      border-radius: 6px;
      padding: 14px 10px 14px 40px;
      height: 100%;
      width: 100%;
      outline: none;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 0.1px;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
    }
  }

  .branchesList {
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing[20]};
    margin-top: ${({ theme }) => theme.spacing[20]};
    padding: ${({ theme }) => theme.spacing[4]};
  }
`;
